export default __webpack_public_path__ + "static/media/episode-08.c460f9de.webp";